import { render, staticRenderFns } from "./DashboardsMenu.vue?vue&type=template&id=4c0655e3&scoped=true&lang=pug&"
import script from "./DashboardsMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardsMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsMenu.vue?vue&type=style&index=0&id=4c0655e3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0655e3",
  null
  
)

export default component.exports